<div *adaptLoading="isBusy">
    @if (!culturalIndicesChartData.length && !showGrid) {
        No Cultural Index has been recorded.
    }

    @if (culturalIndicesChartData.length) {
        <dx-chart class="chart-wrapper mb-3"
                  [dataSource]="culturalIndicesChartData"
                  [pathModified]="true"
                  (onInitialized)="onChartInitialized($event)"
                  [customizePoint]="customiseChartPoint">
            <dxo-chart-argument-axis type="discrete">
                <dxo-chart-grid [opacity]="0.2"
                                [visible]="true"> </dxo-chart-grid>
                <dxo-chart-minor-grid [visible]="false"> </dxo-chart-minor-grid>
                <dxo-chart-label [visible]="false"> </dxo-chart-label>
            </dxo-chart-argument-axis>
            <dxi-chart-value-axis [maxValueMargin]="0.001"
                                  [tickInterval]="0.5"
                                  visualRangeUpdateMode="keep"
                                  [minorTickInterval]="0.1"
                                  [visible]="true"
                                  [visualRange]="[0, 2]">
                <dxo-chart-minor-tick [visible]="true"> </dxo-chart-minor-tick>
                <dxo-chart-label [visible]="false"> </dxo-chart-label>
            </dxi-chart-value-axis>
            <dxi-chart-series type="line"
                              valueField="value"
                              argumentField="creationDate"
                              tagField="culturalIndex"
                              [width]="0.5"> </dxi-chart-series>
            <dxo-chart-tooltip [enabled]="true"
                               [customizeTooltip]="customiseTooltip"> </dxo-chart-tooltip>
            <dxo-chart-legend [visible]="false"> </dxo-chart-legend>
            <dxo-chart-zoom-and-pan argumentAxis="both"> </dxo-chart-zoom-and-pan>
        </dx-chart>
    }

    @if (showGrid) {
        <dx-data-grid [dataSource]="culturalIndices"
                      [wordWrapEnabled]="true"
                      [columnAutoWidth]="true"
                      [rowAlternationEnabled]="true"
                      [hoverStateEnabled]="true"
                      noDataText="No Cultural Index recorded"
                      [showRowLines]="true"
                      [showBorders]="true"
                      itemTemplate="notesTemplate"
                      (onInitialized)="onGridInitialized($event)">
            <dxo-data-grid-pager [showPageSizeSelector]="true"> </dxo-data-grid-pager>
            <dxo-data-grid-paging [pageSize]="5"> </dxo-data-grid-paging>
            <dxo-data-grid-export [enabled]="true"
                                  fileName="Cultural Index history"> </dxo-data-grid-export>
            <div *dxTemplate="let item of 'notesTemplate'">
                <div [froalaView]="item.data.notes"></div>
            </div>
            <dxi-data-grid-column caption="Date"
                                  dataField="creationDate"
                                  dataType="date"
                                  [format]="DateFormats.globalize.short"
                                  sortOrder="desc"
                                  [sortIndex]="0"
                                  [width]="100"> </dxi-data-grid-column>
            <dxi-data-grid-column caption="Cultural Index"
                                  dataField="value"
                                  dataType="number"
                                  [customizeText]="customiseColumnIndexGridText"
                                  [cellTemplate]="culturalIndexCellTemplate"
                                  [width]="145"> </dxi-data-grid-column>
            <dxi-data-grid-column dataField="direction"
                                  dataType="string"
                                  [width]="110">
                <dxo-data-grid-lookup [dataSource]="culturalIndexService.directions"
                                      valueExpr="id"
                                      displayExpr="label"></dxo-data-grid-lookup>
            </dxi-data-grid-column>
            @if (showNotes) {
                <dxi-data-grid-column dataField="notes"
                                      dataType="string"
                                      cellTemplate="notesTemplate"> </dxi-data-grid-column>
            }
        </dx-data-grid>
    }
</div>
